import axios from 'axios'

const defaultBaseURL =
  process.env.NODE_ENV === 'production'
    ? 'https://accum.cloud/api/v1'
    : 'http://localhost:8000/api/v1'

const baseURL = process.env.REACT_APP_API_BASE_URL || defaultBaseURL

const commonAPIParam = {
  baseURL,
  timeout: 60000,
  headers: {
    'Content-Type': 'application/json',
    'Access-Control-Allow-Origin': '*',
    'Access-Control-Allow-Methods': 'POST,GET,PUT,DELETE',
    'Access-Control-Allow-Headers': 'Content-Type'
  }
}
export const client = axios.create(commonAPIParam)
client.interceptors.request.use((config) => {
  return config
})
client.interceptors.response.use(
  (response) => response,
  (error: any) => {
    if (error.code === 'ERR_NETWORK') {
      return Promise.reject({
        data: {
          code: 'ERR_NETWORK',
          message: 'ネットワークエラー'
        }
      })
    } else {
      const errorData = error.response.data
      return Promise.reject({
        data: {
          code: errorData.statusCode,
          message: errorData.message
        }
      })
    }
  }
)

export const guardClient = axios.create(commonAPIParam)
guardClient.interceptors.request.use((config) => {
  const auth = localStorage.getItem('auth')
  if (auth) {
    const authJson = JSON.parse(auth)
    config.headers.Authorization = `Bearer ${authJson.token}`
  } else {
    console.error('access token')
  }
  return config
})
guardClient.interceptors.response.use(
  (response) => response,
  (error: any) => {
    if (error.code === 'ERR_NETWORK') {
      return Promise.reject({
        data: {
          code: 'ERR_NETWORK',
          message: 'ネットワークエラー'
        }
      })
    } else {
      const errorData = error.response.data
      return Promise.reject({
        data: {
          code: errorData.statusCode,
          message: errorData.message
        }
      })
    }
  }
)
